export default "__VITE_ASSET__vafqlLtl__";